<template>
  <div></div>
</template>

<script>
import Constants from "../../constants";

export default {
    name: "LandingPage",
    data () {
        return {
            imgs: [{img: "/wellcomeImages/BYPPAY-16.png", title: this.$t('LandingPage.FAST'), description: this.$t('LandingPage.Thanks to its BlockChain technology, Bypay allows you to create in a few hours a direct payment agreement between customers and providers')}, {img: "/wellcomeImages/BYPPAY-14.png", title: this.$t('LandingPage.ECONOMIC'), description: this.$t('LandingPage.Byppay avoids the consequences of being an intermediary between customer and provider. Byppay does not depend on any bank')}, {img: "/wellcomeImages/BYPPAY-13.png", title: this.$t('LandingPage.SAFE'), description: this.$t('LandingPage.Bypay uses DLT technology to secure payment agreements between customer-provider.')}],
            video: "/wellcomeVideos/byppay.mp4",
        };
    },
    computed: {
        darkMode () {
            return this.$vuetify.theme.dark;
        }
    },
    mounted () {
        if (this.$route.params.color && this.$route.params.message) {
            this.$root.$emit('show-snackbar', {message: this.$route.params.message, color: this.$route.params.color});
        }
    },
    methods: {
        golanding () {
            window.location.replace(Constants.LANDING_BASE_URL + '/landingPage');
        },
        goApp () {
            window.location.replace(Constants.BASE_URL + '/login');
        },
        moreInfo () {
            this.$router.push({name: 'MoreInfo', replace: true});
        },
        LandingA () {
            this.$router.push({name: 'LandingAC', replace: true});
        },
        next () {
            if (this.$user) this.$router.push({name: 'imageInvoice', replace: true});
            else this.$router.push({name: 'Login', replace: true});
        }
    },
};
</script>

<style scoped>
.v-item--active + span + .v-icon {
  color: #FF6961 !important;
}
.container-video {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
}
.video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
